var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueCtkDateTimePicker',_vm._g(_vm._b({ref:"parent",attrs:{"disabled-dates":_vm.getDisabledDates(),"enabled-dates":_vm.getEnabledDates(),"format":_vm.format},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'VueCtkDateTimePicker',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }